const MB_TO_BYTE_MULTIPLAYER = 1048576

/**
 * Check if file size less than
 * @param file
 * @param maxSizeMB
 * @returns {boolean}
 */
export function checkFileSize(file, maxSizeMB) {
  return file.size > maxSizeMB * MB_TO_BYTE_MULTIPLAYER
}

/**
 * Check if file accept
 *
 * @param file
 * @param accept
 * @returns {boolean}
 */
export function checkFileFormat(file, accept) {
  const extension = file.name.split('.').pop().toLowerCase()
  return !accept.includes(extension)
}

export function download(data, name) {
  const blob = data instanceof Blob ? data : new Blob([data])
  const fileURL = window.URL.createObjectURL(blob)
  const fileLink = document.createElement('a')
  fileLink.href = fileURL
  fileLink.setAttribute('download', name)
  document.body.appendChild(fileLink)
  fileLink.click()
  document.body.removeChild(fileLink)
  // revoking right after click() can abort the download in some browsers (Edge)
  setTimeout(() => {
    window.URL.revokeObjectURL(fileURL)
  }, 60000)
}

export function openFile(file, newTab = true) {
  const fileURL = window.URL.createObjectURL(file)
  if (newTab) {
    const link = document.createElement('a')
    link.href = fileURL
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else {
    window.location.assign(fileURL)
  }
  // remove file from browser memory in 120 seconds
  setTimeout(() => {
    window.URL.revokeObjectURL(fileURL)
  }, 120000)
}

